// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1wR9X","footer":"ModalCreateQualiphyProcedure_footer__2uoEP","additionData":"ModalCreateQualiphyProcedure_additionData__1Aj0E"};